module.exports = __webpack_public_path__ + "img/estate-placeholder.db435e86.jpg";